module.exports = __webpack_public_path__ + "static/media/electronic-store.ad1cfd37.jpg";